import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  btn: {
    height: '100%',
    padding: 0,
  },
}))
export default styles
